import get from 'lodash/get';
import createConsts from '../../utils/redux/consts';
import { consts as logout } from '../auth/logout';
import { createActions } from '../../utils/redux';

const supportedActions = ['ADD', 'UPDATE', 'REMOVE'];

export const consts = createConsts(
  'context',
  'loggedUser',
  ...supportedActions,
);
export const actions = createActions(consts);

// retrieved data
const user = window.storage.getItem('user');
const initialState = user ? JSON.parse(user) : {};

const addUser = (state, payload) => {
  return (
    get(payload, 'user') || get(payload, 'authentication.user') || payload || {}
  );
};

const reducer = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case consts.ADD:
      return addUser(state, payload);
    case consts.UPDATE:
      return payload;
    case consts.REMOVE:
    case logout.CLEAR:
      return {};
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/context/loggedUser.js